module.exports = __webpack_public_path__ + "img/tiktok-icon.b304f1f.svg";